import React from 'react';
import { Image } from "@nextui-org/react";

const ImageWithLoader = ({ src, alt, width, height, className }) => {
    return (
        <Image
            src={src}
            alt={alt}
            width={width}
            height={height}
            className={className}
            loading="lazy"
            isBlurred
            disableSkeleton={false}
        />
    );
};

export default ImageWithLoader; 
